var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductT2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9376 11.4254C12.037 11.4254 12.9242 12.3107 12.9242 13.3992L12.9242 36.8435C12.9242 37.9308 12.0369 38.8172 10.9376 38.8172C9.83825 38.8172 8.95094 37.9308 8.95094 36.8435L8.95094 13.4006C8.95094 12.3117 9.83844 11.4254 10.9376 11.4254Z",
    fill: "url(#paint0_linear_7153_14002)",
    stroke: "#187C85",
    strokeWidth: 0.99929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8687 4.83055L19.9516 4.83055C21.1211 4.87931 22.1312 5.95475 22.1312 7.37729L22.1312 36.2688C22.1312 37.7233 21.0727 38.8172 19.8687 38.8172C18.6646 38.8172 17.6061 37.7233 17.6061 36.2688L17.6061 7.37902C17.6061 5.92295 18.6644 4.83055 19.8687 4.83055Z",
    fill: "url(#paint1_linear_7153_14002)",
    stroke: "#187C85",
    strokeWidth: 0.99929
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0757 1.1478L29.1564 1.1478C30.2874 1.20121 31.3382 2.37096 31.3382 4.01522L31.3382 35.9479C31.3382 37.6295 30.2367 38.8172 29.0757 38.8172C27.9147 38.8172 26.8132 37.6295 26.8132 35.9479L26.8132 4.01714C26.8132 2.3338 27.9145 1.1478 29.0757 1.1478Z",
    fill: "url(#paint2_linear_7153_14002)",
    stroke: "#187C85",
    strokeWidth: 0.99929
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 6.1709V43.0001H37.9151",
    stroke: "#187C85",
    strokeWidth: 1.33239,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14002",
    x1: 21.9764,
    y1: 4.46407,
    x2: 12.8965,
    y2: 36.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14002",
    x1: 32.1326,
    y1: -3.63391,
    x2: 19.9271,
    y2: 35.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14002",
    x1: 41.3396,
    y1: -8.15505,
    x2: 26.7172,
    y2: 34.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductT2);
export default __webpack_public_path__ + "static/media/product-t2.864777fde66cbd955b6fa804378dec9e.svg";
export { ForwardRef as ReactComponent };